import type { WeatherLayerOptions } from '@xweather/mapsgl'
import type { XWeatherContext } from '@/fish/providers/x-weather'

export const MS_HOUR = 3600 * 1000
export const MS_DAY = 24 * MS_HOUR

export const XWEATHER_WIND_LAYER = 'wind-particles'

// Color stops used for legend and wind particles
export const COLORS_STOPS = [
  '#72a8cf',
  '#8ecc62',
  '#edcf49',
  '#d87728',
  '#bb323b',
  '#39224f',
]

// Config options for xweather wind layer API
export const XWEATHER_WIND_CONFIG: Partial<WeatherLayerOptions> = {
  timing: {
    clamp: 'none',
  },
  paint: {
    sample: {
      colorscale: {
        range: { min: 0, max: 40 },
        stops: [
          // 0-3mph
          0,
          COLORS_STOPS[0],
          // 4-12
          4,
          COLORS_STOPS[1],
          // 13-18
          13,
          COLORS_STOPS[2],
          // 19-24
          19,
          COLORS_STOPS[3],
          // 25-38
          25,
          COLORS_STOPS[4],
          // 39+
          39,
          COLORS_STOPS[5],
        ],
      },
    },
    particle: {
      density: 64,
      size: 3,
      speed: 3,
      trailsFade: 0.9,
    },
  },
}

export const setWindLayer = (
  toggleState: boolean,
  xWeatherContext: XWeatherContext
) => {
  if (!xWeatherContext.controller) {
    return
  }
  toggleState
    ? xWeatherContext.controller.addWeatherLayer(
        XWEATHER_WIND_LAYER,
        XWEATHER_WIND_CONFIG
      )
    : xWeatherContext.controller.removeWeatherLayer(XWEATHER_WIND_LAYER)
}
